export default __webpack_public_path__ + "static/media/mail_0001.d461e389.jpg";